define("shared/components/shared/ui/feature-header", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <header
    class={{concat-classes (if this.shouldAddLinkinbioHeaderClass "cLB--page__header") "o--page__header"}}
    ...attributes
  >
    {{#if @showMobileMenu}}
      <Shared::Ui::MobileMenu />
    {{/if}}
  
    {{#if @title}}
      <h2 class="o--page__h1 {{@titleQaClass}}">
        {{@title}}
      </h2>
    {{/if}}
  
    {{#if @showBetaLabel}}
      <Shared::Badge @className={{concat-classes "cVL--badge--superscript is--beta" @badgeClass}} />
    {{/if}}
  
    {{#if @titleDivider}}
      <span>{{svg-jar "nav-right" class="o--icon--sm u--m__lr__sm qa--page__headerIcon"}}</span>
    {{/if}}
  
    {{#if @showLogo}}
      <span class="o--page__logo">
        <span class="img--logo"></span>
      </span>
    {{/if}}
  
    {{#if (has-block)}}
      {{yield}}
    {{/if}}
  </header>
  */
  {
    "id": "TGLC4dM3",
    "block": "[[[11,\"header\"],[16,0,[28,[37,0],[[52,[30,0,[\"shouldAddLinkinbioHeaderClass\"]],\"cLB--page__header\"],\"o--page__header\"],null]],[17,1],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[8,[39,2],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[10,\"h2\"],[15,0,[29,[\"o--page__h1 \",[30,4]]]],[12],[1,\"\\n      \"],[1,[30,3]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[8,[39,3],null,[[\"@className\"],[[28,[37,0],[\"cVL--badge--superscript is--beta\",[30,6]],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,7],[[[1,\"    \"],[10,1],[12],[1,[28,[35,4],[\"nav-right\"],[[\"class\"],[\"o--icon--sm u--m__lr__sm qa--page__headerIcon\"]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,8],[[[1,\"    \"],[10,1],[14,0,\"o--page__logo\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"img--logo\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[48,[30,9]],[[[1,\"    \"],[18,9,null],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@showMobileMenu\",\"@title\",\"@titleQaClass\",\"@showBetaLabel\",\"@badgeClass\",\"@titleDivider\",\"@showLogo\",\"&default\"],false,[\"concat-classes\",\"if\",\"shared/ui/mobile-menu\",\"shared/badge\",\"svg-jar\",\"has-block\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/feature-header.hbs",
    "isStrictMode": false
  });

  /**
   * This component renders the header in a consistent manner across all feature pages, and is used in both Simple & Block form.
   * Currently all block usage should also include the titleDivider property, however in the future you will be able to pass in elements
   * that can be forced to the right side of the page (removing the need for a visual divider). For mobile view, this renders the hamburger
   * menu on the left hand side; display is controlled via css media queries.
   *
   * Required Arguments:
   * - None
   *
   * Optional Arguments:
   * - title (String) The title of the page to be displayed in the header. Should be brought in through the internationalization (t) helper
   *   rather than entered directly through text. While optional, this component probably isn't the correct one if you're not going to include it.
   * - titleDivider (Boolean) The > divider separating the title from the contents of the yielded block. Include if the block is going to be added
   *   next to the title.
   * - showMobileMenu (Boolean) Display the hamburger menu
   * - showLogo (Boolean) Display the Later Logo
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Ui::FeatureHeader @title="Name of the page" />
   * ```
   *
   * Block Usage:
   *
   * When invoked as a Block component, the block content is added after the title. Any custom HTML/Components can be used inside the block.
   * ```
   * <Shared::Ui::FeatureHeader
   *   @title="Page Title"
   *   @titleDivider={{true}}>
   *   <p>secondary title or block</p>
   * </Shared::Ui::FeatureHeader>
   * ```
   */
  class FeatureHeaderComponent extends _component2.default {
    get shouldAddLinkinbioHeaderClass() {
      return this.args.isLinkinbio && this.args.showMobileMenu;
    }

  }

  _exports.default = FeatureHeaderComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeatureHeaderComponent);
});